<template>
    <div class="dashboard-page bold tablec">
        <div class="d-flex flex-row">
            <Widget title="Leaderboard" :fetching-data="isReceiving" class="w-100">
                <div class="w-25 float-right mb-3">
                    <v-select
                        id="search-select"
                        v-model="selectedBehaviour"
                        :options= "leaderboardBehaviours"
                        @input="onBehaviourSelect"

                    />
                </div>
                <div class="table-resposive" v-if="leaderboard && leaderboard.length > 0">

                    <b-button v-if="selectedBehaviour.id == null" variant="success"
                              @click="refreshGeneralLeaderboard($toasted)" class="mb-4 mt-3">
                        Refresh general leaderboard
                    </b-button>
                    <div class="abc-checkbox abc-checkbox-primary mb-4" v-if="hasAdminRole()">
                        <input type="checkbox"
                               id="allowGlobalVisibility"
                               v-model="selectedCountry.allowGlobalVisibility"
                               @change="toggleAllowGlobalVisibility()"
                        />
                        <label for="allowGlobalVisibility">Allow global visibility</label>
                    </div>
                    <table class="table">
                        <thead>
                        <tr>
                            <th class="hidden-sm-down">#</th>
                            <th>Full name</th>
                            <th class="hidden-sm-down">Stars</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(row, i) in leaderboard" :key="row.id">
                            <td>{{row.place}}</td>
                            <td>
                                <img v-if="row.avatarUrl" class="profileAvatar rounded-circle mr-2" style="vertical-align: middle; width: 50px;
                              height: 50px; border-radius: 50%;" :src="row.avatarUrl" alt="..." />
                                <img v-else class="profileAvatar rounded-circle mr-2" style="vertical-align: middle; width: 50px;
                              height: 50px; border-radius: 50%;" src="../../assets/people/default_avatar.png" alt="..." />
                                {{row.fullName}}
                            </td>
                            <td class="text-semi-muted">
                                {{Math.round(row.score * 100) / 100}}
                            </td>
                            <td class="width-150">
                                <b-progress variant="success" :value="row.score" :max="leaderboard[0].score"
                                        class="progress-sm mb-xs"
                                />
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
                <h5 class="pt-4" v-else> No scores registered yet!</h5>
            </Widget>
        </div>
    </div>
</template>

<script>
  import Loader from "../../components/Loader/Loader";
  import {mapActions, mapState} from "vuex";
  import Widget from "../../components/Widget/Widget";
  import vSelect from "vue-select";

  export default {
    name: "Leaderboard",
    components: {Loader, Widget, vSelect},
    computed: {
      ...mapState("auth", ["currentUser"]),
      ...mapState("leaderboard", ["leaderboard", "isReceiving"]),
      ...mapState("behaviours", ["behaviours"]),
      ...mapState("countries", ["selectedCountry", "countries"]),
    },
    watch: {
        selectedCountry: function (val) {
            this.getBehavioursRequest(val.id);
            this.selectedBehaviour = {id: null, label: 'All behaviours'};
            this.getLeaderboardRequest({behaviourId:null, countryIds: this.getGlobalLeaderboardCountryIds()});
        },
        behaviours: function (val) {
            this.leaderboardBehaviours = [];
            this.leaderboardBehaviours = val.map(b => Object.assign({}, b, {label: b.title}))
            this.leaderboardBehaviours.push({id: null, label: 'All behaviours'})
        },
    },
    data() {
      return {
        leaderboardBehaviours: [],
        selectedBehaviour: {id: null, label: 'All behaviours'},
        user: JSON.parse(localStorage.getItem('user') || {}),
        users:[
          {
            id: 1,
            fullName:'Maria Carneci',
            stars: 100,
            avatarUrl: '/img/a2.65b83bd6.jpg'
          },
          {
            id: 2,
            fullName:'Florina Marinescu',
            stars: 83,
            avatarUrl: '/img/a1.617f6789.jpg'
          },
          {
            id: 3,
            fullName:'Matei Capmare',
            stars: 67,
            avatarUrl: "/img/a5.84f014f0.jpg"
          },
          {
            id: 4,
            fullName:'Florin Ilie',
            stars: 62,
            avatarUrl: '/img/a4.3ceb7ef6.jpg'
          }
        ],
        viewMenu: false,
        globalVisibility: false,
        top: '0px',
        left: '0px',
        selectedLinkItem: null
      };
    },
    methods: {
      ...mapActions("auth", ["fetchCurrentUser"]),
      ...mapActions("behaviours", ["getBehavioursRequest"]),
      ...mapActions("countries", ["updateCountryRequest"]),
      ...mapActions("leaderboard", ["getLeaderboardRequest", "refreshGeneralLeaderboard"]),
      onBehaviourSelect(behaviour){
        this.getLeaderboardRequest({behaviourId: behaviour.id, countryIds: this.getGlobalLeaderboardCountryIds()});
      },
      async toggleAllowGlobalVisibility(){
          await this.updateCountryRequest({
              id: this.selectedCountry.id,
              country: {
                  allowGlobalVisibility: this.selectedCountry.allowGlobalVisibility != null ? this.selectedCountry.allowGlobalVisibility : true
              },
              successMessage: "Update successfully made!",
              $toasted: this.$toasted
          })
      },
      hasAdminRole(){
        const user = this.currentUser ? this.currentUser : this.user;
        if(user && this.countries && this.selectedCountry) {
            const selectedCountryId = this.selectedCountry.id;
            const selectedCountry = this.countries.filter(c => c.id == selectedCountryId)
            if (selectedCountry && selectedCountry.length > 0) {
                const countryData = selectedCountry[0];
                const userAuthorities = user.userAuthorities;
                const adminAuthorities = userAuthorities.filter(a => a.role == 'ROLE_ROOT'
                    || (a.role == 'ROLE_ADMIN' && countryData.code === a.tenantCode))
                if (adminAuthorities.length > 0) {
                    return true;
                }
            }
        }
        return false;
      },
      getGlobalLeaderboardCountryIds(){
          const user = this.currentUser ? this.currentUser : this.user;
          let result = [];
          if(user && this.countries) {
              const userAuthorities = user.userAuthorities;
              const adminCountryCodes = userAuthorities.filter(a => a.role == 'ROLE_ADMIN').map(auth => auth.tenantCode)
              const adminCountries = this.countries.filter(c => adminCountryCodes.includes(c.code) )
              result = adminCountries.map(c => c.id)
              this.countries.forEach(c => {
                  if(c.allowGlobalVisibility && !result.includes(c.id))
                      result.push(c.id);
              })

          }
          return result

      }
    },
    async mounted() {

      if(this.currentUser == undefined || this.currentUser.id == null) {
        await this.fetchCurrentUser();
      }

      if(this.currentUser && this.currentUser.selectedCountryId){
        this.getBehavioursRequest(this.currentUser.selectedCountryId);
      }

      this.getLeaderboardRequest({behaviourId: null, countryIds: this.getGlobalLeaderboardCountryIds()});

      if (this.behaviours) {
        this.leaderboardBehaviours = this.behaviours.map(b => Object.assign({}, b, {label: b.title}))
        this.leaderboardBehaviours.push({id: null, label: 'All behaviours'})
      } else {
        this.leaderboardBehaviours = [];
      }
    }
  }
</script>

<style scoped/>
